<template>
  <div class="home">
    <p class="h3 home__title">Список площадок</p>
    <div class="home__panel">
      <AppMenu
        v-model="activeMenuItem"
        :items="menuItems"
      />
      <BaseButton
        theme="light"
        class="button"
        href="/create-field"
      >
        + Добавить площадку
      </BaseButton>
    </div>

    <KeepAlive>
      <component
        :is="componentName"
        class="window"
      />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import BaseButton from '@/components/Base/BaseButton'
import AppMap from './components/AppMap'
import AppList from './components/AppList'

export default {
  name: 'home',
  components: {
    AppMap,
    AppList,
    BaseButton,
    AppMenu
  },
  data () {
    return {
      menuItems: [
        { value: 'list', label: 'Список', component: 'AppList' },
        { value: 'map', label: 'Карты', component: 'AppMap' }
      ],
      activeMenuItem: 'list'
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  },
  watch: {
    activeMenuItem (newValue) {
      this.$router.push({
        path: this.$route.fullPath,
        query: { tab: newValue }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  color: #C6C6CE;
  display: flex;
  flex-direction: column;

  &__title {
    color: #fff;
  }

  &__panel {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button {
      padding: 0 20px;
    }
  }

  .window {
    //flex-grow: 1;
    height: 800px;
    margin-top: 20px;
  }
}
</style>
